module.exports = __webpack_public_path__ + "84acac25d5cee5b6fa95af95908bff94.svg";